import React from "react";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const ActiveUsers = ({ title, percentage, chart, isLoading }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card p="16px">
      <CardBody>
        <Flex direction="column" w="100%">
          {isLoading ? <Skeleton height="200px" /> : chart}
          
          <Flex direction="column" mt="24px" mb="36px" alignSelf="flex-start">
            <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
              {isLoading ? <Skeleton width="150px" /> : title}
            </Text>
            <Text fontSize="md" fontWeight="medium" color="gray.400">
              {isLoading ? (
                <Skeleton width="100px" />
              ) : (
                <>
                  <Text
                    as="span"
                    color={percentage > 0 ? "green.400" : "red.400"}
                    fontWeight="bold"
                  >
                    {percentage > 0 ? `+${percentage}%` : `${percentage}%`}
                  </Text>{" "}
                  than last week
                </>
              )}
            </Text>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default ActiveUsers;
